import React from 'react';
import { Helmet } from 'react-helmet';
import '../pages/MetroLandingPage.css'

export default function MetroLandingPage({ onSelect, onBack }) {
  return (
    <>
      <Helmet>
        <title>DC Metro Analysis | Insight Data LLC</title>
      </Helmet>

      <div className='ml-home-container'>
        <div className='ml-tile-box'>

          <div className='ml-back-button'>
            <button onClick={onBack} className="back-link">
               Back to Projects
            </button>
          </div>

          <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5rem', color: '#222' }}>
            Welcome to the DC Metro Explorer
          </h1>
          <p style={{ fontSize: '1.125rem', marginBottom: '1.5rem', color: '#444' }}>
            This project demonstrates a complete data engineering workflow, from raw ingestion to advanced network analysis.
          </p>

          <ol style={{ textAlign: 'left', marginBottom: '1.5rem', paddingLeft: '1.25rem' }}>
            <li><strong>Data Ingestion:</strong> Fetch live API and flat file sources using Python scripts.</li>
            <li><strong>Raw Storage:</strong> Store unprocessed data in Amazon S3 buckets.</li>
            <li><strong>Modeling:</strong> Use dbt with DuckDB (on S3) to transform and organize data.</li>
            <li><strong>Warehouse:</strong> Load curated tables into Snowflake for scalable querying.</li>
            <li><strong>Analysis & Visualization:</strong> Explore data in Jupyter notebooks; build network graphs with NetworkX and React.</li>
            <li><strong>Frontend & Hosting:</strong> Build and deploy the interactive React application via S3/CloudFront.</li>
          </ol>
          
          <div>
            <h4 style={{ fontSize: '1rem', marginBottom: '0.5rem', color: '#222' }}>
              Explore the DC Metro usge with aggregated data from May 2012
            </h4>
          </div>

          <div className='ml-tile-header'>

            {/* <button className='ml-button'
              onClick={() => onSelect('entries')}
              style={{
                background: '#0039A6',
              }}
            >
              View Entries
            </button>
            
            <button className='ml-button'
              onClick={() => onSelect('exits')}
              style={{
                background: '#DA291C',
              }}
            >
              View Exits
            </button> */}

            <button className='ml-button'
              onClick={() => onSelect('usage')}
              style={{
                background: '#0039A6',
              }}
            >
              Explore Station Usage
            </button>
          </div>

          <div style={{ textAlign: 'right', marginTop: '1rem' }}>
            <a
              href="https://github.com/jakobjgu/dc_public_transport"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#0039A6', fontSize: '0.875rem' }}
            >
              View GitHub Repo
            </a>
          </div>

          <div className='ml-image-credit'>
          Background image by WMATA
        </div>
        </div>
      </div>
    </>
  );
}
